document.addEventListener('DOMContentLoaded', () => {
  // Select all carousel containers
  const carousels = document.querySelectorAll('.feature-image-carousel');

  carousels.forEach((carousel) => {
    const carouselContainer = carousel.querySelector('.carousel-container');
    const items = carousel.querySelectorAll('.carousel-item');
    const leftArrow = carousel.querySelector('.left-arrow');
    const rightArrow = carousel.querySelector('.right-arrow');

    let scrollAmount = 0;

    function scrollCarousel(direction) {
      const itemWidth = items[0].offsetWidth + 20; // Item width + padding
      const maxScroll = carouselContainer.scrollWidth - carouselContainer.clientWidth;

      scrollAmount += direction * itemWidth;

      if (scrollAmount >= maxScroll) {
        scrollAmount = maxScroll;
      }

      if (scrollAmount < 0) {
        scrollAmount = 0;
      }

      carouselContainer.scrollTo({
        left: scrollAmount,
        behavior: 'smooth',
      });
    }

    // Attach event listeners for this carousel's arrows
    leftArrow.addEventListener('click', () => scrollCarousel(-1));
    rightArrow.addEventListener('click', () => scrollCarousel(1));
  });
});